import HeaderMenu from "./components/HeaderMenu/HeaderMenu";
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";

import OurStory from "./screens/OurStory/OurStory";
import Home from "./screens/Home/Home";
import Footer from './components/Footer/Footer';
import Login from "./screens/Login/Login";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute";

import styles from './App.module.scss';
import ReCAPTCHA from "react-google-recaptcha";
import WeddingParty from "screens/WeddingParty/WeddingParty";
import ScrollToTop from "./components/ScrollToTop";
import { AuthProvider } from "./hooks/useAuth";
import FAQ from "screens/FAQ/FAQ";

export default function App() {
  return ( 
      <Router>
        <ScrollToTop />
        <div className={styles.appContainer}>
          <AuthProvider>
            <HeaderMenu />
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route element={<ProtectedRoute />}>
                <Route path="/our-story" element={<OurStory />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/wedding-party" element={<WeddingParty />} />
                <Route path="/" element={<Home />} />
                <Route path="*" element={<Home />} />
              </Route>
            </Routes>
            <Footer /> 
          </AuthProvider>
          <div className={styles.recaptcha}>
            <ReCAPTCHA sitekey={process.env.REACT_APP_SITE_KEY} size="invisible" />
          </div>
        </div>
      </Router>
  );
}